var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages-top",on:{"click":_vm.animation}},[(!_vm.isClick)?_c('div',{staticClass:"svg-anim-area star"},[_c('img',{attrs:{"src":require('../assets/svg/star.svg'),"width":"400","height":"400"}})]):_vm._e(),_vm._v(" "),(_vm.isClick)?_c('components-top-effect',{staticClass:"svg-anim-area topeffect"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b14292","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Top.vue
// module id = null
// module chunks = 